<template>
  <v-dialog :value="value" max-width="380" @input="$emit('input', $event)">
    <v-card>
      <v-card-title
        class="text-subtitle-1 font-weight-bold white--text py-3"
        style="background: #0f3565;"
      >
        <v-icon small left color="white">mdi-eye-off-outline</v-icon>
        {{ $t('Colunas ocultas') }}
        <v-spacer></v-spacer>
        <v-btn icon dark small @click="$emit('input', false)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4 pb-2 px-4">
        <v-list dense class="pa-0">
          <v-list-item
            v-for="col in hiddenColumns"
            :key="col.idx"
            class="px-0"
            style="min-height: 40px;"
          >
            <v-list-item-content>
              <v-list-item-title class="text-body-2">{{ $t(col.label) }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <v-btn
                icon
                small
                color="#0f3565"
                :title="$t('Mostrar coluna')"
                @click="$emit('show-column', col.idx)"
              >
                <v-icon small>mdi-eye-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-4 py-3">
        <v-btn text small @click="$emit('input', false)">{{ $t('Fechar') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          small
          color="#0f3565"
          dark
          @click="$emit('show-all'); $emit('input', false)"
        >
          <v-icon small left>mdi-eye-outline</v-icon>
          {{ $t('Mostrar todas') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HiddenColumnsModal',
  props: {
    value: { type: Boolean, default: false },
    hiddenColumns: { type: Array, default: () => [] },
  },
}
</script>
